import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Ticket"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.75 10.5C22.1642 10.5 22.5 10.1642 22.5 9.75V6C22.5 5.17157 21.8284 4.5 21 4.5H3C2.17157 4.5 1.5 5.17157 1.5 6V9.75C1.5 10.1642 1.83579 10.5 2.25 10.5C3.07843 10.5 3.75 11.1716 3.75 12C3.75 12.8284 3.07843 13.5 2.25 13.5C1.83579 13.5 1.5 13.8358 1.5 14.25V18C1.5 18.8284 2.17157 19.5 3 19.5H21C21.8284 19.5 22.5 18.8284 22.5 18V14.25C22.5 13.8358 22.1642 13.5 21.75 13.5C20.9216 13.5 20.25 12.8284 20.25 12C20.25 11.1716 20.9216 10.5 21.75 10.5ZM14.25 9.75H15.75V14.25H14.25V9.75ZM21 18V14.9025C19.6797 14.5574 18.7586 13.3647 18.7586 12C18.7586 10.6353 19.6797 9.44259 21 9.0975V6H15.75V8.25H14.25V6H3V9.0975C4.32033 9.44259 5.24139 10.6353 5.24139 12C5.24139 13.3647 4.32033 14.5574 3 14.9025V18H14.25V15.75H15.75V18H21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Ticket.vue"]]);
